'use strict';

import { SemanticVersion } from './semantic-version';

export function parse(
  version: SemanticVersion | string,
  throwErrors: false,
): SemanticVersion | null;
export function parse(version: SemanticVersion | string, throwErrors: true): SemanticVersion;
export function parse(
  version: SemanticVersion | string,
  throwErrors: boolean = false,
): SemanticVersion | null {
  if (version instanceof SemanticVersion) {
    return version;
  }
  try {
    return new SemanticVersion(version);
  } catch (er) {
    if (!throwErrors) {
      return null;
    }
    throw er;
  }
}
